import * as React from 'react';

import { ButtonTwo, Button, Box, IInputCallbackData, Input, ButtonIcon, IButtonComponentProps } from '@moosend/mooskin';

export interface IFileUploadProps extends IButtonComponentProps {
	onFileChange?: (e: React.ChangeEvent<HTMLInputElement>, data: IInputCallbackData) => void;
	dataLabel?: string;
	children?: string;
	accept?: string;
	value?: string;
	inverseStyle?: boolean;
}

const fileInputId = 'file-upload-input';

export const FileUploadButton: React.FC<IFileUploadProps> = (props) => {
	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files && e.target.files.length) {
			props.onFileChange && props.onFileChange(e, { dataLabel: props.dataLabel, value: e.target.files[0] });
		}
	};

	const onClick = () => {
		const input = document.getElementById(`${fileInputId}-${props.dataLabel}`);
		input?.click();
	};

	const ButtonComponent = props.inverseStyle ? ButtonTwo : Button;

	return (
		<Box w="fit-content" position="relative">
			<ButtonComponent buttonSize="sm" p="8px 15px" onClick={onClick} {...props}>
				{props.children}
			</ButtonComponent>
			<Input onChange={onChange} d="none" id={`${fileInputId}-${props.dataLabel}`} accept={props.accept} type="file" />
		</Box>
	);
};

FileUploadButton.displayName = 'FileUploadButton';

export const FileUploadInput: React.FC<IFileUploadProps> = (props) => {
	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files && e.target.files.length) {
			props.onFileChange && props.onFileChange(e, { dataLabel: props.dataLabel, value: e.target.files[0] });
		}
	};

	const onClick = () => {
		const input = document.getElementById(fileInputId);
		input?.click();
	};

	return (
		<Box d="flex" onClick={onClick}>
			<Input d="none" onChange={onChange} id={fileInputId} accept={props.accept} type="file" />
			<Input cursor="pointer" disabled value={props.value} type="text" />
			<Button ml={-2} borderTopLeftRadius={0} borderBottomLeftRadius={0} buttonSize="sm" p="8px 15px" {...props}>
				BROWSE
			</Button>
		</Box>
	);
};

FileUploadInput.displayName = 'FileUploadInput';

export interface IUploadPreview {
	src: string;
	onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

export const UploadPreview: React.FC<IUploadPreview> = (props) => {
	return (
		<Box boxShadow="md" d="flex">
			<Box d="flex" align="center" justify="center" p={5} borderTopLeftRadius="3px" borderBottomLeftRadius="3px">
				<img className="seo-favicon-image" width={28} height={28} src={props.src} />
			</Box>
			<Button borderTopLeftRadius={0} borderBottomLeftRadius={0} onClick={props.onClick}>
				<ButtonIcon>delete</ButtonIcon>
			</Button>
		</Box>
	);
};

UploadPreview.displayName = 'UploadPreview';
